module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e88kP"))).then(() => module.bundle.root('fThBo'));